import { useEffect, useState } from 'react';
import axios from '../axios/AxiosInstance';
const endpoint = 'user/me/mission-templates';
const presets = [
  { _id: 'base-general', name: 'Mission à compléter', task: 'Objectif de la mission :\n[Préciser l’objectif]\n\nTâches principales :\n- [Tâche 1]\n- [Tâche 2]\n- [Tâche 3]\n\nOrganisation :\n[Préciser l’équipe, les outils et les consignes utiles]' },
  { _id: 'base-logistique', name: 'Logistique et manutention', task: '- Réceptionner et contrôler les marchandises.\n- Préparer, emballer et organiser les commandes.\n- Participer au rangement et au suivi des stocks.\n- Maintenir la zone de travail propre et respecter les consignes du site.' },
  { _id: 'base-restauration', name: 'Restauration et service', task: '- Préparer et mettre en place les espaces de service.\n- Accueillir les clients et participer au service.\n- Débarrasser, ranger et nettoyer les espaces de travail.\n- Collaborer avec l’équipe selon les consignes du responsable.' },
  { _id: 'base-accueil', name: 'Accueil et administratif', task: '- Accueillir et orienter les visiteurs ou interlocuteurs.\n- Traiter les appels et demandes courantes.\n- Saisir, vérifier et classer les documents.\n- Transmettre les informations à l’équipe concernée.' },
  { _id: 'base-soins', name: 'Accompagnement et soins', task: '- Participer à l’accompagnement des personnes selon le poste et la qualification.\n- Réaliser les tâches prévues dans la fiche de poste.\n- Transmettre les observations utiles à l’équipe.\n- Appliquer les protocoles et les consignes de l’établissement.' },
];
export default function MissionTemplates({ task, onApply }) {
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState('');
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [feedback, setFeedback] = useState('');
  const personal = templates.find(item => item._id === selected);
  useEffect(() => {
    let active = true;
    axios.get(endpoint).then(({ data }) => { if (active) setTemplates(Array.isArray(data) ? data : []); })
      .catch(() => { if (active) setError('Vos modèles personnels ne sont pas disponibles. Vous pouvez utiliser les modèles proposés ou saisir vos missions.'); });
    return () => { active = false; };
  }, []);
  const apply = id => {
    setSelected(id); setError(''); setFeedback('');
    const model = [...templates, ...presets].find(item => item._id === id);
    if (!model) { setName(''); return; }
    onApply(model.task);
    setName(templates.includes(model) ? model.name : '');
    setFeedback('Modèle appliqué. Personnalisez les tâches ci-dessous.');
  };
  const save = async copy => {
    setError(''); setFeedback('');
    if (!name.trim() || !task?.trim()) { setError('Renseignez un nom et les tâches/missions avant d’enregistrer.'); return; }
    setBusy(true);
    try {
      const updating = personal && !copy;
      const { data } = await axios[updating ? 'put' : 'post'](updating ? `${endpoint}/${personal._id}` : endpoint, { name: name.trim(), task });
      setTemplates(current => updating ? current.map(item => item._id === data._id ? data : item) : [...current, data]);
      setSelected(data._id); setName(data.name);
      setFeedback(updating ? 'Modèle mis à jour.' : 'Modèle enregistré sur votre compte.');
    } catch (e) { setError(e.response?.data?.message || 'Impossible d’enregistrer le modèle. Réessayez.'); }
    finally { setBusy(false); }
  };
  const remove = async () => {
    if (!personal) return;
    setBusy(true); setError(''); setFeedback('');
    try {
      await axios.delete(`${endpoint}/${personal._id}`);
      setTemplates(current => current.filter(item => item._id !== personal._id));
      setSelected(''); setName(''); setFeedback('Modèle supprimé. Le texte de la commande est conservé.');
    } catch { setError('Impossible de supprimer le modèle.'); }
    finally { setBusy(false); }
  };
  const button = 'rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium disabled:opacity-50';
  return <fieldset className="mt-3 rounded-xl border border-slate-200 bg-slate-50 p-4">
    <legend className="px-1 text-sm font-semibold text-slate-700">Modèle de tâches / missions</legend>
    <label className="block text-sm text-slate-600" htmlFor="mission-template">Partir d’un modèle</label>
    <select id="mission-template" value={selected} disabled={busy} onChange={event => apply(event.target.value)} className="mt-2 w-full rounded-lg border border-slate-200 bg-white p-2 text-sm">
      <option value="">Choisir un modèle</option>
      <optgroup label="Modèles proposés">{presets.map(model => <option key={model._id} value={model._id}>{model.name}</option>)}</optgroup>
      {!!templates.length && <optgroup label="Mes modèles">{templates.map(model => <option key={model._id} value={model._id}>{model.name}</option>)}</optgroup>}
    </select>
    <details className="mt-3">
      <summary className="cursor-pointer text-sm font-medium text-blue-700">Enregistrer cette mission comme modèle</summary>
      <label htmlFor="mission-template-name" className="mt-3 block text-sm">Nom du modèle</label>
      <input id="mission-template-name" value={name} onChange={event => setName(event.target.value)} maxLength={100} disabled={busy} placeholder="Ex. : Préparation de commandes" className="mt-1 w-full rounded-lg border border-slate-200 bg-white p-2 text-sm" />
      <div className="mt-3 flex flex-wrap gap-2">
        <button type="button" className={button} disabled={busy} onClick={() => save(false)}>{personal ? 'Mettre à jour le modèle' : 'Enregistrer le modèle'}</button>
        {personal && <><button type="button" className={button} disabled={busy} onClick={() => save(true)}>Créer une copie</button><button type="button" className={`${button} text-red-700`} disabled={busy} onClick={remove}>Supprimer le modèle</button></>}
      </div>
    </details>
    {error && <p role="alert" className="mt-2 text-sm text-red-700">{error}</p>}
    {feedback && <p role="status" className="mt-2 text-sm text-green-700">{feedback}</p>}
  </fieldset>;
}
